import { LayerTypeDTO, ScoreDefinitionDTO } from 'business/models/Models';
import React from 'react';
import { OptimizationIngredientName } from './OptimizationWizard';

export const OptimizationContext = React.createContext({
  layerType: LayerTypeDTO.Grid,
  setLayerType: (e) => {},
  substituteStock: false,
  setSubstituteStock: (e) => {},
  isNewExperiment: false,
  setIsNewExperiment: (e) => {},
  openExperiment: true,
  setOpenExperiment: (e) => {},
  experimentId: -1,
  setExperimentId: (e) => {},
  sourceExperimentId: -1,
  setSourceExperimentId: (e) => {},
  nextEnabled: false,
  setNextEnabled: (e) => {},
  setShow: (e) => {},
  experimentName: '',
  setExperimentName: (e: string): void => {},
  experimentUrl: '',
  setExperimentUrl: (e: string): void => {},
  isoScores: [],
  setIsoScores: (e: ScoreDefinitionDTO[]) => void {},
  selectedWellsIngredientData: [],
  isoPrecipitantIngs: [],
  isoDisabled: false,
  plateTypeId: 0,
  setPlateTypeId: (id: number): void => {},
  backDisabled: true,
  setBackDisabled: (e: boolean): void => {},
  explorerBroadcastChannel: null,
  parentTreeNodeId: undefined,
} as OptimizationContextData);

type OptimizationContextData = {
  layerType: LayerTypeDTO;
  setLayerType: (e: any) => void;
  substituteStock: boolean;
  setSubstituteStock: (e: any) => void;
  isNewExperiment: boolean;
  setIsNewExperiment: (e: any) => void;
  openExperiment: boolean;
  setOpenExperiment: (e: any) => void;
  experimentId: number;
  setExperimentId: (e: any) => void;
  sourceExperimentId: number;
  setSourceExperimentId: (e: any) => void;
  nextEnabled: boolean;
  setNextEnabled: (e: any) => void;
  setShow: (e) => void;
  experimentName: string;
  setExperimentName: (e: string) => void;
  experimentUrl: string;
  setExperimentUrl: (e: string) => void;
  isoScores: ScoreDefinitionDTO[];
  setIsoScores: (e: ScoreDefinitionDTO[]) => void;
  selectedWellsIngredientData: OptimizationIngredientName[];
  isoPrecipitantIngs: OptimizationIngredientName[];
  isoDisabled: boolean;
  plateTypeId: number;
  setPlateTypeId: (id: number) => void;
  backDisabled: boolean;
  setBackDisabled: (e: boolean) => void;
  explorerBroadcastChannel: BroadcastChannel;
  parentTreeNodeId: number | undefined;
};
